module.exports = __webpack_public_path__ + "static/media/icon-dot-gov.42b4ac46.svg";